var map = {
	"./Slider": 32,
	"./Slider.jsx": 32,
	"./Slider.module.css": 18,
	"./img/leftArrow.png": 68,
	"./img/right.png": 69,
	"./img/slide1.jpg": 70,
	"./img/slide2.png": 71,
	"./img/slide3.png": 72,
	"./img/slide4.png": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;